// extracted by mini-css-extract-plugin
export default {"container":"MediaGroupSidebar_container__67o3F","loading":"MediaGroupSidebar_loading__T5UYR"};